var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4418 16C17.4802 15.672 17.5 15.3383 17.5 15C17.5 10.3056 13.6944 6.5 8.99997 6.5C8.81623 6.5 8.63385 6.50583 8.453 6.51732C9.45485 3.87683 12.0083 2 15 2C18.866 2 22 5.13401 22 9C22 10.933 21.2165 12.683 19.9497 13.9497L21.1464 15.1464C21.4614 15.4614 21.2383 16 20.7929 16H17.4418Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22C12.866 22 16 18.866 16 15C16 11.134 12.866 8 9 8C5.13401 8 2 11.134 2 15C2 16.933 2.7835 18.683 4.05025 19.9497L2.85355 21.1464C2.53857 21.4614 2.76165 22 3.20711 22H9ZM6.5 15C6.5 15.5523 6.05228 16 5.5 16C4.94772 16 4.5 15.5523 4.5 15C4.5 14.4477 4.94772 14 5.5 14C6.05228 14 6.5 14.4477 6.5 15ZM10 15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15ZM12.5 16C11.9477 16 11.5 15.5523 11.5 15C11.5 14.4477 11.9477 14 12.5 14C13.0523 14 13.5 14.4477 13.5 15C13.5 15.5523 13.0523 16 12.5 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble18);
export default __webpack_public_path__ + "static/media/speech-bubble-18.3f514dc5e93431e06ca2617adc5215c2.svg";
export { ForwardRef as ReactComponent };